import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type SelectDateState = {
  shouldSelectDate: boolean;
};

const initialState: SelectDateState = {
  shouldSelectDate: false,
};

const selectDateSlice = createSlice({
  name: 'selectDate',
  initialState,
  reducers: {
    setShouldSelectDate(state, action: PayloadAction<boolean>) {
      state.shouldSelectDate = action.payload;
    },
  },
});

export const { setShouldSelectDate } = selectDateSlice.actions;
export default selectDateSlice.reducer;
